<script lang="ts">
export const elFileVariants = ['primary', 'alpha', 'outlined'] as const;
export type ElFileVariant = (typeof elFileVariants)[number];
</script>

<script setup lang="ts">
import ElIcon from '@/ElIcon.vue';
import ElIconButton from '@/ElIconButton.vue';

defineProps<{
  variant: ElFileVariant;
  name: string;
  format?: string;
  disabled?: boolean;
  url?: string;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
}>();
</script>
<template>
  <div
    class="p-2 inline-flex gap-2 items-center min-w-36 max-w-full"
    :class="{
      'bg-neutral-surface text-neutral-darker border-neutral-surface rounded border': variant === 'primary',
      'bg-alpha-500 text-neutral-inverse rounded-lg': variant === 'alpha',
      'bg-neutral-surface text-neutral-darker border-neutral-surface rounded-lg border': variant === 'outlined',
    }"
  >
    <!-- Icon -->
    <div
      class="flex items-center justify-center rounded flex-shrink-0"
      :class="{
        'bg-alpha-300 h-9 w-9 rounded': variant === 'alpha',
        'h-9 w-9 border-neutral-surface rounded border': variant === 'outlined',
      }"
    >
      <ElIcon :name="variant === 'primary' ? 'DocumentArrowUpIcon' : 'DocumentTextIcon'" class="w-5 h-5" />
    </div>

    <!-- File -->
    <div
      class="text-xs grow flex flex-col gap-1 flex-nowrap overflow-hidden whitespace-nowrap"
      :class="{
        'max-w-72': variant !== 'primary',
      }"
    >
      <span class="overflow-hidden font-medium text-ellipsis">{{ name }}</span>
      <span v-if="format && variant != 'primary'" class="font-normal overflow-hidden text-ellipsis">{{ format }}</span>
    </div>

    <!-- Action Button -->
    <ElIconButton
      v-if="variant === 'primary'"
      class="flex-shrink-0"
      size="xs"
      :icon="{
        name: 'XMarkIcon',
      }"
      :disabled="disabled"
      @click="emit('close')"
    />
  </div>
</template>
